import React, { useEffect, useState } from "react";
import { useGetAllUsersDataQuery } from "../../RTKQuery/CsvDataService/csvDataApi";
import Loader from "../Loader/Loader";
import PageComponentHeader from "../PageComponentHeader";
import FilterDrawer from "../UIKit/Drawer";
import ConditionalFilters from "../ConditionalFilters";
import { useLazyExportUsersQuery } from "../../RTKQuery/CsvDataService/csvDataApi";
// import ExportButton from "../UIKit/Buttons/Export";
import DataTable from "../UIKit/CollapsibleTable";
import Upload from "../Modals/Upload/Upload";
import MappingModal from "../Modals/MappingModal/MappingModal";
import { Button } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useSelector } from "react-redux";
import ExportWithOptionsButton from "../UIKit/Buttons/ExportWithOptions";
import { userListColumns } from "../../constants/tableColumns";

export default function UsersList({ filters, setFilters }) {
  const files = useSelector((state) => state.file.files);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [sorting, setSorting] = useState([]);
  const [usersData, setUsersData] = useState([]);
  // Filters
  const [closeFilterMenu, setCloseFilterMenu] = useState(true);
  const [filterCount, setFilterCount] = useState(1);
  const [conditionCount, setConditionCount] = useState(0);
  const [subConditionCount, setSubConditionCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [triggerExport, { isLoading }] = useLazyExportUsersQuery();

  const [uploadModal, setUploadModal] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [mapModal, setMapModal] = useState(false);
  const [uploadTypeApollo, setUploadTypeApollo] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [exportFilters, setExportFilters] = useState([]);

  const defaultFilter = [
    {
      id: "f-1",
      first: true,
      conditions: [
        {
          id: "f-10",
          first: true,
          subConditions: [],
          filter: "f-1",
        },
      ],
    },
  ];
  const [filterData, setFilterData] = useState(defaultFilter);

  // Applying Filters
  const {
    data,
    loading: dataLoading,
    refetch,
  } = useGetAllUsersDataQuery({
    pagination,
    sorting,
    filters: JSON.stringify(filters),
  });

  const handleApplyFilters = () => {
    setPagination({ ...pagination, pageIndex: 0 });
    setFilters(filterData);
    setExportFilters(filterData);
    setCloseFilterMenu(true);
  };

  const handleResetFilters = () => {
    // setCurrentPage(0)
    setPagination({ ...pagination, pageIndex: 0 });
    setExportFilters([]);
    setFilterData([
      {
        id: "f-1",
        first: true,
        conditions: [
          {
            id: "f-10",
            first: true,
            subConditions: [],
            filter: "f-1",
          },
        ],
      },
    ]);
    setFilters([]);
    setCloseFilterMenu(true);
  };

  const handleUploadModal = (bool) => {
    setShowMap(bool);
    setUploadModal(true);
  };

  const handleUploadUsers = () => {
    setUploadTypeApollo(false);
    handleUploadModal(true);
  };

  useEffect(() => {
    // refetch()
    if (dataLoading) {
      // console.log("loading");
      // setLoading(dataLoading);
    }
    if (data) {
      setLoader(false);
      setUsersData(data.users);
    }
  }, [data, usersData, dataLoading]);

  useEffect(() => {
    refetch();
  }, [files]);

  return (
    <div>
      <PageComponentHeader allowBack={false} pageTitle={"Users Management"}>
        <Button
          startIcon={<UploadFileIcon />}
          color="primary"
          variant="contained"
          sx={{ color: "#F3F3F3" }}
          onClick={handleUploadUsers}
        >
          Upload CSV
        </Button>
        {/* <ExportButton onClick={handleExport} isLoading={isLoading} /> */}
        <ExportWithOptionsButton
          filters={exportFilters}
          sorting={sorting}
          total={data?.total}
        />
        <FilterDrawer
          close={closeFilterMenu}
          setClose={setCloseFilterMenu}
          filters={filters}
          setCloseFilterMenu={setCloseFilterMenu}
        >
          <>
            <ConditionalFilters
              onReset={handleResetFilters}
              onSubmit={handleApplyFilters}
              filtersArray={filterData}
              setFiltersArray={setFilterData}
              setCloseFilterMenu={setCloseFilterMenu}
              filterCount={filterCount}
              setFilterCount={setFilterCount}
              conditionCount={conditionCount}
              setConditionCount={setConditionCount}
              subConditionCount={subConditionCount}
              setSubConditionCount={setSubConditionCount}
              defaultFilter={defaultFilter}
            />
          </>
        </FilterDrawer>
      </PageComponentHeader>
      {data?.users.length === 0 ? (
        <h3 className="noData">No Record Found</h3>
      ) : !loader && data?.users.length > 0 ? (
        <div style={{ marginTop: "1rem" }}>
          <DataTable
            columns={userListColumns}
            data={usersData}
            totalData={data.total}
            sorting={sorting}
            setSorting={setSorting}
            pagination={pagination}
            setLoader={setLoader}
            setPagination={setPagination}
          />
        </div>
      ) : (
        <div className="noData">
          <Loader />
        </div>
      )}
      <Upload
        open={uploadModal}
        setOpen={setUploadModal}
        setMapModal={setMapModal}
        showMap={showMap}
        setShowMap={setShowMap}
        uploadTypeApollo={uploadTypeApollo}
        BtnText={uploadTypeApollo ? "Upload Apollo Csv" : "Upload Csv"}
        uploading={uploading}
        setUploading={setUploading}
        refetchData={refetch}
      />
      <MappingModal
        open={mapModal}
        setOpen={setMapModal}
        uploadTypeApollo={uploadTypeApollo}
        setUploading={setUploading}
        setUploadModal={setUploadModal}
        // setShowAlert={setShowAlert}
        // setSeverity={setSeverity}
        // setMessage={setMessage}
      />
    </div>
  );
}
